$(document).on('turbolinks:load', () => {
  // Define the URL to fetch the latest status
  const url = '/admin/runsheets/status'
  // Define the interval to fetch the status
  const interval = 3000
  let fetchStatusInterval;

  // Define the function to fetch the status
  const fetchStatus = () => {
    $.get(url, function(data) {
      console.log(data);
      if (data.status == 'processing') {
        $('#processing').show();
      }
      else {
        $('#processing').hide();
      }
      $('#download').toggleClass('disabled', data.status === 'processing');
    });
  }

  const startFetchingStatus = () => {
    if (window.location.pathname === '/admin/runsheets') {
      fetchStatus();
      fetchStatusInterval = setInterval(fetchStatus, interval);
    }
  }

  const stopFetchingStatus = () => {
    if (fetchStatusInterval) {
      clearInterval(fetchStatusInterval);
    }
  }

  startFetchingStatus();

  $(document).on('turbolinks:before-cache', stopFetchingStatus);
});
